var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckCircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.498 6.2767 13.8126 4.62456 12.594 3.40601C11.3754 2.18745 9.7233 1.50199 8 1.5ZM11.0957 6.86182L7.42871 10.3618C7.33548 10.4505 7.21171 10.5 7.08301 10.5C6.95432 10.5 6.83054 10.4505 6.73731 10.3618L4.9043 8.61182C4.80854 8.52008 4.7531 8.39409 4.75016 8.26151C4.74723 8.12894 4.79704 8.00062 4.88865 7.90474C4.98026 7.80886 5.10618 7.75326 5.23875 7.75015C5.37132 7.74705 5.49971 7.7967 5.59571 7.88818L7.08301 9.30859L10.4043 6.13818C10.5003 6.0467 10.6287 5.99705 10.7613 6.00015C10.8938 6.00326 11.0198 6.05886 11.1114 6.15474C11.203 6.25062 11.2528 6.37894 11.2498 6.51152C11.2469 6.64409 11.1915 6.77008 11.0957 6.86182Z",
    fill: "#0D814A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleCheck);
export default __webpack_public_path__ + "static/media/green-circle-check.0c4fa14b82b4c875b078a3c78e05576b.svg";
export { ForwardRef as ReactComponent };